import {
  TClearGeoType,
  TGeocodeType,
  TGetGeoSuggestionsType,
  TGetMetaType,
  TSelectGeoType,
  TSelectOfferTypeType,
  TSetBSCentersType,
  TSetBuilderType,
  TSetDealTypeType,
  TSetJsonQueryType,
  TSetMaxPriceType,
  TSetMinPriceType,
  TSetRegionType,
  TSetVillageType,
} from '../../actions/filters';
import { TSelectAllOfferTypesType } from '../../actions/filters/selectAllOfferTypes';

export const FILTERS_SET_DEAL_TYPE_TYPE: TSetDealTypeType = 'filters/set_deal_type';
export const FILTERS_SELECT_OFFER_TYPE_TYPE: TSelectOfferTypeType = 'filters/select_offer_type';
export const FILTERS_SELECT_ALL_OFFER_TYPES_TYPE: TSelectAllOfferTypesType = 'filters/select_all_offer_types';
export const FILTERS_SELECT_COWORKING_OFFER_TYPE_TYPE = 'filters/select_coworking_offer_type' as const;
export const FILTERS_SET_MIN_PRICE_TYPE: TSetMinPriceType = 'filters/set_min_price';
export const FILTERS_SET_MAX_PRICE_TYPE: TSetMaxPriceType = 'filters/set_max_price';
export const FILTERS_SET_PRICE_TYPE = 'filters/set_price_type' as const;
export const FILTERS_GET_META_TYPE: TGetMetaType = 'filters/get_meta/status_changed';
export const FILTERS_SET_REGION_ID_TYPE: TSetRegionType = 'filters/set_region';
export const FILTERS_SET_JSON_QUERY_TYPE: TSetJsonQueryType = 'filters/set_json_query';
export const FILTERS_GET_GEO_SUGGESTIONS_TYPE: TGetGeoSuggestionsType = 'filters/geo/get_suggestions/status_changed';
export const FILTERS_SET_VILLAGE_TYPE: TSetVillageType = 'filters/set_village';
export const FILTERS_SET_BS_CENTERS_TYPE: TSetBSCentersType = 'filters/set_bs_centers';
export const FILTERS_SELECT_GEO_TYPE: TSelectGeoType = 'filters/geo/select_geo';
export const FILTERS_CLEAR_GEO_TYPE: TClearGeoType = 'filters/geo/clear_geo';
export const FILTERS_GEOCODE_TYPE: TGeocodeType = 'filters/geocode/status_changed';
export const FILTERS_SET_BUILDER_TYPE: TSetBuilderType = 'filters/set_builder';
export const FILTERS_SET_MIN_WORKPLACE_COUNT_TYPE = 'filters/set_min_workplace_count';
export const FILTERS_SET_MAX_WORKPLACE_COUNT_TYPE = 'filters/set_max_workplace_count';
export const FILTER_SET_COWORKING_ID_TYPE = 'filters/set_coworking_id';
export const FILTERS_SET_SPECIALTY_TYPES_TYPE = 'filters/set_specialty_types_type' as const;
